import { CONTROL_Z_INDEX } from '../../constants';

export const DURATION_MARKER_Z_INDEX = CONTROL_Z_INDEX;

export const ICON_MARKER_Z_INDEX = CONTROL_Z_INDEX + 2;

export const DEFAULT_MARKER_Z_INDEX = CONTROL_Z_INDEX + 1;

export const EXPANDED_MARKER_Z_INDEX = CONTROL_Z_INDEX + 4;
